import "core-js/modules/es.function.name.js";

/* eslint-disable camelcase */
import React from 'react';
import { dateFormat, fundsFromName } from 'enums';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var partnerFundsColumns = [{
  name: 'Сума',
  render: function render(_ref) {
    var amount = _ref.amount,
        currency = _ref.currency;
    return ___EmotionJSX("span", null, amount, " ", currency);
  }
}, {
  name: 'Валута',
  value: 'currency'
}, {
  name: 'Дата',
  value: 'created_at',
  dateTimeFormat: dateFormat
}, {
  name: 'Потребител',
  render: function render(_ref2) {
    var _created_by$name;

    var created_by = _ref2.created_by;
    return ___EmotionJSX("span", null, (_created_by$name = created_by === null || created_by === void 0 ? void 0 : created_by.name) !== null && _created_by$name !== void 0 ? _created_by$name : '-');
  }
}, {
  name: 'Основание',
  render: function render(_ref3) {
    var _fundsFromName$from;

    var from = _ref3.from;
    return ___EmotionJSX("span", null, (_fundsFromName$from = fundsFromName[from]) !== null && _fundsFromName$from !== void 0 ? _fundsFromName$from : from);
  }
}, {
  name: 'Кредит №',
  render: function render(_ref4) {
    var _credit$number;

    var credit = _ref4.credit;
    return ___EmotionJSX("span", null, (_credit$number = credit === null || credit === void 0 ? void 0 : credit.number) !== null && _credit$number !== void 0 ? _credit$number : '-');
  }
}, {
  name: 'Главница',
  render: function render(_ref5) {
    var principal_amount = _ref5.principal_amount;
    return ___EmotionJSX("span", null, principal_amount !== null && principal_amount !== void 0 ? principal_amount : '-');
  }
}, {
  name: 'Лихва',
  render: function render(_ref6) {
    var interest_amount = _ref6.interest_amount;
    return ___EmotionJSX("span", null, interest_amount !== null && interest_amount !== void 0 ? interest_amount : '-');
  }
}, {
  name: 'Такса дом. посещение',
  render: function render(_ref7) {
    var home_visit_fee_amount = _ref7.home_visit_fee_amount;
    return ___EmotionJSX("span", null, home_visit_fee_amount !== null && home_visit_fee_amount !== void 0 ? home_visit_fee_amount : '-');
  }
}, {
  name: 'Неустойка',
  render: function render(_ref8) {
    var penalty_amount = _ref8.penalty_amount;
    return ___EmotionJSX("span", null, penalty_amount !== null && penalty_amount !== void 0 ? penalty_amount : '-');
  }
}, {
  name: 'Такси',
  render: function render(_ref9) {
    var fee_amount = _ref9.fee_amount;
    return ___EmotionJSX("span", null, fee_amount !== null && fee_amount !== void 0 ? fee_amount : '-');
  }
}];